import { useMediaQuery } from "@mantine/hooks";

import { AnalyzeLoader } from "#modules/quoteRequestLines/AnalyzeLoader";
import { Flex } from "#shared/view/components/Flex";

type Props = {
  text: string;
};

export const AnalyzingState = ({ text }: Props) => {
  const largeScreen = useMediaQuery("(min-width: 750px)");

  return (
    <Flex justify={"end"} align={largeScreen ? "center" : "end"} h={"100%"}>
      <AnalyzeLoader text={text} />
    </Flex>
  );
};
